export const GEOAPIFY_API_KEY = "4144396561c9450cadf9f538abe07b3e";
export const GEMINI_API_KEY = "AIzaSyD_tI0C79u2MvGxeoSWXsMeMZUFFY-7iPk"; 